"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.put = exports.get = void 0;

var http_1 = require("./http");

var uri = "/v4/user/metadata";

function get(credentials, domain, key) {
  var parts = "/" + domain + (key != null ? "/" + key : "");
  return http_1.authorizedHTTP(credentials).get(uri + parts, {
    baseURL: "https://id.comsel.net"
  }).then(function (resp) {
    if (resp.data != null && resp.data.key != null) {
      // if we are getting a singe metadata we should wrap it in array
      return [resp.data];
    }

    return resp.data;
  });
}

exports.get = get;

function put(credentials, domain, key, value) {
  var parts = "/" + domain + "/" + key;
  return http_1.authorizedHTTP(credentials).put(uri + parts, value, {
    baseURL: "https://id.comsel.net"
  }).then(function (resp) {
    return resp.data;
  });
}

exports.put = put;